module.exports = __webpack_public_path__ + "95be0bc6822bec589d676bcf7646e640.obj";